var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.327 51.1244C51.0235 50.5071 49.0595 49.0001 47.8671 46.9348C46.6747 44.8695 46.3515 42.4151 46.9688 40.1116C47.586 37.808 49.093 35.844 51.1583 34.6516C53.2236 33.4592 55.678 33.1361 57.9816 33.7533C60.2851 34.3705 62.2491 35.8776 63.4415 37.9429C64.6339 40.0082 64.9571 42.4626 64.3398 44.7661C64.0342 45.9067 63.5069 46.976 62.7881 47.9128C62.0692 48.8496 61.1729 49.6357 60.1503 50.2261C59.1276 50.8165 57.9987 51.1997 56.828 51.3538C55.6572 51.508 54.4676 51.43 53.327 51.1244ZM62.1707 18.1194C55.7208 16.3911 48.8485 17.2959 43.0656 20.6346C37.2828 23.9733 33.0631 29.4725 31.3348 35.9225C26.4475 54.1621 43.5524 87.6036 43.5524 87.6036C43.5524 87.6036 75.0865 67.1948 79.9738 48.9552C81.702 42.5053 80.7973 35.633 77.4586 29.8501C74.1198 24.0673 68.6206 19.8476 62.1707 18.1194Z",
    fill: "#B1DA81"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLocation);
export default __webpack_public_path__ + "static/media/mdi_location.67b40ba67c5fbf1bcb06e11b6799e145.svg";
export { ForwardRef as ReactComponent };